// @flow
import React from 'react';
import {BottomSheetModal} from '@homeaway/react-modal';
import {ButtonLink} from '@homeaway/react-buttons';
import {FormattedMessage} from 'react-intl';

import type {Node} from 'react';

type MobileProps = {
    content: string,
    children: Node,
    isModalOpen: boolean,
    setModalOpen: (isModalOpen: boolean) => void
};

const DualPriceTooltipMobile = ({
    content,
    children,
    isModalOpen,
    setModalOpen
}: MobileProps) => {
    const title = (
        <FormattedMessage
            id={'propertyTotalPrice'}
            description={'Total price'}
            defaultMessage={'View details for price'}
        />
    );

    const openModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setModalOpen(!isModalOpen);
    };

    let parentNode;
    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
        parentNode = document.getElementsByClassName('HitCollection')[0];
    }

    return (
        // stop propagation to not trigger hit selected events
        <div className="DualPriceTooltip" onClick={(e) => e.stopPropagation()}>
            <ButtonLink onClick={openModal} label={children} />
            <BottomSheetModal
                id="DualPriceTooltip"
                isOpen={isModalOpen}
                parentNode={parentNode}
                onClose={() => setModalOpen(!isModalOpen)}
                title={title}
            >
                {content}
            </BottomSheetModal>
        </div>
    );
};

export default DualPriceTooltipMobile;
